import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconTelemetry = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = colors.nero }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M4 6L5 7L3 9H13V11H3L5 13L4 14L0 10L4 6ZM10 0L14 4L10 8L9 7L11 5H1V3H11L9 1L10 0Z' fill={color} />
    </svg>;
};

IconTelemetry.propTypes = {
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    color: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconTelemetry;
